/* eslint-disable custom/no-restricted-translation-jsx-untranslated-children-text */
import React from 'react';

import { Typography } from '@mui/material';

import { useIntl } from '@kamernet/core/Intl';
import { Locale } from '@kamernet/core/Intl/types';

import styles from './Content.module.css';

interface ContentStreetGenericProps {
  streetName: string;
  cityName: string;
}

export const ContentStreetGeneric = ({
  streetName,
  cityName,
}: ContentStreetGenericProps) => {
  const { locale } = useIntl();

  return locale === Locale.en ? (
    <React.Fragment>
      <Typography variant="h1" className={styles.title}>
        {`Homes for rent in ${streetName}, ${cityName}`}
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        {`Looking for rental properties on ${streetName} in ${cityName}? Look no further!
        Kamernet offers a diverse selection of recently available rental homes
        along ${streetName}. Explore the latest rental listings and discover your
        next rental property with ease. Our extensive range of rental options
        ensures that you can find something to fit your needs and budget for
        every price range and level of amenities.`}
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        {`Finding your ideal home on ${streetName} has never been simpler. With our
        user-friendly platform and advanced search filters, you can quickly
        browse through rental properties on ${streetName} in ${cityName}. Whether you're
        looking for mid-range rentals, private rental homes, or properties in
        the city centre, Kamernet has got you covered. Our comprehensive
        listings make it easy to find affordable rental homes or temporary
        residences to suit your lifestyle.`}
      </Typography>
    </React.Fragment>
  ) : (
    <React.Fragment>
      <Typography variant="h1" className={styles.title}>
        {`Huurwoningen in ${streetName}, ${cityName}`}
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        {`Op zoek naar huurwoningen op ${streetName} in ${cityName}? Zoek niet verder!
        Kamernet biedt een gevarieerde selectie van recent beschikbare
        huurwoningen langs ${streetName}. Zoek door het nieuwste aanboden ontdek
        eenvoudig jouw volgende huurwoning. Ons uitgebreide assortiment aan
        huuropties zorgt ervoor dat je voor elk budget en elk niveau van
        voorzieningen iets kunt vinden.`}
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        {`Het vinden van jouw ideale woning op ${streetName} is nog nooit zo eenvoudig
        geweest. Met ons gebruiksvriendelijke platform en geavanceerde
        zoekfilters kun je snel door huurwoningen op ${streetName} in ${cityName} zoeken.
        Of je nu op zoek bent naar middenhuur woningen, particuliere
        huurwoningen, of woningen in het stadscentrum, Kamernet heeft alles wat
        je zoekt. Onze uitgebreide aanbod maakthet gemakkelijk om
        goedkopehuurwoningen of tijdelijke woningente vinden die passen bij jouw
        levensstijl.`}
      </Typography>
    </React.Fragment>
  );
};
